export default __webpack_public_path__ + "static/media/ad_preview_header.49c7e728.svg";